import { useEffect, useRef } from "react";
import { Wrench, AlertTriangle, ShieldQuestion, Sparkles } from "lucide-react";
import { StatusBadge } from "./StatusBadge";

const ts = (d) => new Date(d).toLocaleTimeString("es-UY", { hour12: false, timeZone: "America/Montevideo" });

function ToolChip({ t, onConfirm, i }) {
  const s = t.summary || {};
  return (
    <div className="mt-2 border border-cyan-500/20 bg-slate-900/70 p-2 text-[11px]" data-testid={`chat-tool-${i}`}>
      <div className="flex flex-wrap items-center gap-2">
        <Wrench className="h-3 w-3 text-cyan-400" />
        <span className="text-cyan-200">{t.name}</span>
        <span className="text-slate-500 truncate max-w-[220px]">{JSON.stringify(t.args)}</span>
        <StatusBadge status={s.status} />
        {s.result?.simulated && <span className="text-amber-300 uppercase tracking-widest">simulado</span>}
      </div>
      <div className="mt-1 text-slate-400">{s.result?.error || s.meaning}</div>
      {s.awaiting_confirmation && (
        <button data-testid={`chat-tool-confirm-${i}`} onClick={() => onConfirm({ ...s, tool: s.tool || t.name })}
          className="mt-2 inline-flex items-center gap-1 border border-amber-400/60 px-2 py-1 text-amber-200 hover:bg-amber-500/10 transition-colors">
          <ShieldQuestion className="h-3 w-3" /> Revisar y autorizar
        </button>
      )}
    </div>
  );
}

export function ChatPanel({ messages, onConfirm, interim }) {
  const stream = useRef(null);
  useEffect(() => {
    const box=stream.current;
    if(!box)return;
    const reduced=window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    box.scrollTo?.({top:box.scrollHeight,behavior:reduced?"auto":"smooth"});
  }, [messages, interim]);
  return (
    <div ref={stream} className="conversation-stream flex-1 overflow-y-auto scrollbar-hide space-y-4 px-1 py-2" data-testid="chat-stream">
      {messages.length === 0 && (
        <div className="conversation-empty" data-testid="chat-empty"><span className="conversation-spark"><Sparkles size={18}/></span><div><h2>¿Qué hacemos hoy?</h2><p>Escribí o hablame. Estoy para ayudarte.</p></div></div>
      )}
      {messages.map((m, idx) => (
        <div key={m.id} className={`conversation-message is-${m.role} rise text-sm leading-relaxed`} data-testid={`chat-message-${m.role}-${idx}`}>
          <div className="text-[10px] text-slate-500 mb-0.5">[{ts(m.at)}] {m.role === "user" ? "SEÑOR" : "JARVIS"}</div>
          {m.image && <img src={m.image} alt="adjunto" className="max-h-40 border border-cyan-500/30 mb-1" />}
          <div className={m.role === "user" ? "text-cyan-200" : "text-white whitespace-pre-wrap"}>
            {m.content || (m.pending ? <span className="text-cyan-400 animate-pulse">procesando…</span> : "")}
          </div>
          {(m.tools || []).filter((t) => t.summary).map((t, i) => <ToolChip key={i} i={`${idx}-${i}`} t={t} onConfirm={onConfirm} />)}
          {m.error && (
            <div className="mt-2 flex items-start gap-2 border border-red-500/40 bg-red-950/30 p-2 text-xs text-red-300" data-testid={`chat-error-${idx}`}>
              <AlertTriangle className="h-4 w-4 shrink-0" /> {m.error.message}
            </div>
          )}
          {m.interrupted && <div className="text-[11px] text-slate-500">— interrumpido</div>}
        </div>
      ))}
      {interim && <div className="text-cyan-300/70 text-sm italic" data-testid="chat-interim">«{interim}»</div>}
    </div>
  );
}
